function unsupported(name) {
  throw new Error(`Node crypto.${name} is not available in the browser runtime`)
}

export function createHash() {
  unsupported('createHash')
}

export function createHmac() {
  unsupported('createHmac')
}

export function createCipheriv() {
  unsupported('createCipheriv')
}

export function createDecipheriv() {
  unsupported('createDecipheriv')
}

export function randomBytes(length) {
  const bytes = new Uint8Array(length)
  globalThis.crypto.getRandomValues(bytes)
  return bytes
}

export default {
  createHash,
  createHmac,
  createCipheriv,
  createDecipheriv,
  randomBytes,
}
